export default {
	name: "order-documents-modal",
	props: ["orderId", "heading", "modalId", "showModal"],
	emits: ["closeModal"],
	data() {
		return {
			documents: [],
			documentsHeadings: [
				{
					text: "File Name",
					field: "name"
				},
				{
					text: "Document Type",
					field: "documentType"
				}
			],
			modalHeading: null,
			modalComponentId: null,
			loading: false
		};
	},
	methods: {
		getDocuments(){
			this.loading = true;
			orderService.getDocumentsByOrderId(this.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						this.documents = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadDocument(documentId){
			this.loading = true;
			var selectedDocument = this.documents.find((doc) => doc.documentId === documentId);
			let request = {
				pathToFileStorage: selectedDocument.pathInFileStorage,
				fileName: selectedDocument.name
			};
			orderService.getOrderDocument(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', selectedDocument.name);
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onModalCloseClick(){
			console.log("close clicked");
			this.$emit("closeModal");
		}
	},
	mounted: function () {
		
	},
	watch: {
		orderId:{
			handler: function () {
				if (this.orderId) {
					this.getDocuments();
				}
			},
			immediate: true,
			deep: true
		},
		heading: {
			handler: function () {
				if (this.heading) {
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId: {
			handler: function () {
				if (this.modalId) {
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal: {
			handler: function () {
				console.log("showModal", this.showModal);
				console.log("modalComponentId", this.modalComponentId);
				if (this.showModal) {
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalComponentId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				} else {
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};